import React from "react";
import { cn } from "@/lib/utils";

export type ContentTableProps = {
  children: React.ReactNode;
  className?: string;
  tableClassName?: string;
};

export const ContentTable: React.FC<ContentTableProps> = ({ children, className, tableClassName }) => {
  return (
    <div className={cn("not-prose overflow-x-auto rounded-lg border border-border/60 bg-white shadow-sm", className)}>
      <table className={cn("w-full text-sm", tableClassName)}>
        {children}
      </table>
    </div>
  );
};

export default ContentTable;
